__turbopack_context__.v({
  "icon": "ns8F5q_icon",
});
